import { render, staticRenderFns } from "./TagLink.vue?vue&type=template&id=d9f7d24e"
import script from "./TagLink.vue?vue&type=script&lang=js"
export * from "./TagLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports